export const getOrderedSpecialties = (availableOrder, availableSpecialties) => {
  if (!availableOrder?.length) return availableSpecialties;

  return availableOrder
    .map((code) => availableSpecialties.find((s) => s.value === code))
    .filter(Boolean)
    .concat(availableSpecialties.filter((s) => !availableOrder.includes(s.value)));
};

export const filterSpecialtiesBySearch = (specialties, searchQuery) => {
  if (!searchQuery) return specialties;

  return specialties.filter((s) => s?.label?.toLowerCase().includes(searchQuery.toLowerCase()));
};

export const getSelectedSpecialties = (specialtyCodes, specialtyTypes) => {
  return (specialtyCodes || [])
    .map((code) => specialtyTypes?.find((s) => s.value === code))
    .filter(Boolean);
};

export const getAvailableSpecialties = (specialtyTypes, specialtyCodes) => {
  return specialtyTypes?.filter((s) => !specialtyCodes?.includes(s.value)) || [];
};

// Builds the @hello-pangea/dnd onDragEnd handler for the two specialty lists.
export const createDragEndHandler =
  ({
    availableSpecialties,
    specialtyCodes,
    selectedSpecialties,
    setSpecialtyCodes,
    setSelectedSpecialties
  }) =>
  (result) => {
    if (!result.destination) return;
    const { source, destination, draggableId } = result;

    const getSpecialtyCode = (id) => {
      if (id.startsWith('available-')) return id.replace('available-', '');
      return id;
    };

    const specialtyCode = getSpecialtyCode(draggableId);

    // Cross-list drag: from available to selected
    if (
      source.droppableId === 'availableSpecialties' &&
      destination.droppableId === 'selectedSpecialties'
    ) {
      const specialty = availableSpecialties.find((s) => s.value === specialtyCode);
      if (specialty) {
        setSelectedSpecialties((prev) => {
          const newSelected = [...prev];
          newSelected.splice(destination.index, 0, specialty);
          return newSelected;
        });
      }
      const newCodes = [...(specialtyCodes || [])];
      newCodes.splice(destination.index, 0, specialtyCode);
      setSpecialtyCodes(newCodes);
      return;
    }

    // Cross-list drag: from selected to available (remove from selected)
    if (
      source.droppableId === 'selectedSpecialties' &&
      destination.droppableId === 'availableSpecialties'
    ) {
      setSelectedSpecialties((prev) => prev.filter((s) => s.value !== specialtyCode));
      setSpecialtyCodes((prev) => prev?.filter((c) => c !== specialtyCode) || []);
      return;
    }

    // Same list reordering: selected specialties
    if (
      source.droppableId === 'selectedSpecialties' &&
      destination.droppableId === 'selectedSpecialties'
    ) {
      const newCodes = [...(specialtyCodes || [])];
      const [removed] = newCodes.splice(source.index, 1);
      newCodes.splice(destination.index, 0, removed);
      setSpecialtyCodes(newCodes);

      const newSelected = [...selectedSpecialties];
      const [removedSpecialty] = newSelected.splice(source.index, 1);
      newSelected.splice(destination.index, 0, removedSpecialty);
      setSelectedSpecialties(newSelected);
    }
  };
